import React, { useCallback } from 'react';

import { DateTimePicker, DatePicker } from '@material-ui/pickers';
import { indexOf } from 'lodash';
import PropTypes from 'prop-types';

import * as S from './styles';

export default function MDate({
  time,
  open,
  onClose,
  onSubmit,
  items,
  disablePreviousDate,
  disableFutureDate,
}) {
  const handleCloseDatePicker = useCallback(() => {
    onClose(false);
  }, []);

  const handleChangeValue = useCallback(
    (value) => {
      const isDate = value.format(time ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY');
      const index = indexOf(
        items.map((item) => item.date),
        isDate
      );

      if (index === -1) {
        onSubmit(isDate);
      }
    },
    [time, items]
  );

  if (time)
    return (
      <S.Wrapper>
        <DateTimePicker
          disablePast={disablePreviousDate}
          disableFuture={disableFutureDate}
          open={open}
          onClose={handleCloseDatePicker}
          onChange={handleChangeValue}
          ampm={false}
        />
      </S.Wrapper>
    );

  return (
    <S.Wrapper>
      <DatePicker
        disablePast={disablePreviousDate}
        disableFuture={disableFutureDate}
        open={open}
        onClose={handleCloseDatePicker}
        onChange={handleChangeValue}
      />
    </S.Wrapper>
  );
}

MDate.propTypes = {
  time: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string.isRequired,
    })
  ).isRequired,
  disablePreviousDate: PropTypes.bool.isRequired,
  disableFutureDate: PropTypes.bool.isRequired,
};
